module.exports = __webpack_public_path__ + "static/media/siddhant.68dc6e82.jpg";